import React from 'react';
import { bool, instanceOf, func } from 'prop-types';
import ToggleSwitch from '../../shared/ToggleSwitch';
import AccountsSearchForm from './AccountsSearchForm';
import DECheckbox from '../../shared/DECheckbox';

const ReportsAccounts = ({
  accountLoading,
  accounts,
  onExportAsSeparateChange,
  inSingleFile,
  selectedAccounts = [],
  setSelectedAccounts,
  setAllSelectedAccounts,
  isAccountError,
}) => {
  const [accountsList, setAccounts] = React.useState(accounts);

  React.useEffect(() => {
    setAccounts(accounts);
  }, [accounts]);

  if (accountLoading) {
    return (
      <div className="de--reports--accounts--col">
        <div className="de--reports--card">
          <div className="de--reports--card--title">
            <h4>
              <span>Accounts</span>
            </h4>
          </div>
          <div className="de--reports--card--body">loading...</div>
        </div>
      </div>
    );
  }
  if (accounts.length === 0) {
    return (
      <div className="de--reports--accounts--col">
        <div className="de--reports--card">
          <div className="de--reports--card--title">
            <h4>
              <span>Accounts</span>
            </h4>
          </div>
          <div className="de--reports--card--body">No accounts found.</div>
        </div>
      </div>
    );
  }
  const _renderAccountList = () => {
    if (accountsList.length > 0) {
      return accountsList.map(account => {
        let labelClass = 'de--reports--accounts--label';
        if (selectedAccounts.includes(account.accountId)) {
          labelClass += ' de--reports--accounts--label-selected';
        }
        return (
          <li
            key={account.accountId}
            className="de--reports--accounts--list-item"
          >
            <div className="de--reports--accounts--custom-checkbox">
              <DECheckbox
                onChange={() => setSelectedAccounts(account)}
                id={`account_${account.accountId}`}
                isChecked={selectedAccounts.includes(account.accountId)}
                data-test = 'DECheckbox'
              />
              <label
                htmlFor={`account_${account.accountId}`}
                className={labelClass}
              >
                <span title={account.accountName}>{account.accountName}</span>
              </label>
            </div>
          </li>
        );
      });
    }
    return (
      <li className="de--reports--accounts--list-item">
        <div className="de--reports--accounts--custom-checkbox">
          No account found.
        </div>
      </li>
    );
  };

  const _handleAccountSearchChange = value => {
    // console.log(value);
    const userInput = value;
    // Filter our options that don't contain the user's input
    const filteredOptions = accounts.filter(
      account =>
        account.accountName.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    // setAllSelectedAccounts([])
    setAccounts(filteredOptions);
  };
  const _onExportAsSeparateChange = value => {
    onExportAsSeparateChange(value);
  };

  const selectAllAccount = isChecked => {
    const allAccountIds = accountsList.map(account => account.accountId);
    const filteredAccountIds = [];
    selectedAccounts.map(accountId => {
      if (!allAccountIds.includes(accountId)) {
        filteredAccountIds.push(accountId)
      }
      return null;
    });
    setAllSelectedAccounts(isChecked ? [...selectedAccounts, ...allAccountIds] : filteredAccountIds);
  };


  let isIndeterminate = false;
  let isAllAccountSelected = false;
  // if (selectedAccounts.length > 0) {
  //   isIndeterminate = true;
  //   isAllAccountSelected = true;
  //   if (selectedAccounts.length === accounts.length) {
  //     isIndeterminate = false;
  //   }
  // }
  const isSelectedAccountInSearched = accountsList.filter(account => selectedAccounts.includes(account.accountId))
  if (isSelectedAccountInSearched.length > 0) {
    isIndeterminate = true
    isAllAccountSelected = true;
  } else if (selectedAccounts.length === accounts.length) {
    isIndeterminate = false;
  }

  return (
    <div className="de--reports--accounts--col">
      <div className="de--reports--card de--reports--accounts--card o-hide">
        <div className="de--reports--card--title">
          <h4>
            <span>Accounts</span>
          </h4>
        </div>
        <div className="de--reports--card--body">
          <div className="de--reports--accounts--form">
            <div className="de--reports--accounts--checkbox">
              <div>
                <ToggleSwitch
                  id="exportAsSeparate"
                  checked={inSingleFile}
                  onChange={_onExportAsSeparateChange}
                  disabled={selectedAccounts.length <= 1}
                />
                <label htmlFor="exportAsSeparate">
                  Export accounts as separate documents
                </label>
              </div>
            </div>

            <div className="de--reports--accounts--search">
              <AccountsSearchForm
                onChange={_handleAccountSearchChange}
                disabled={accounts.length === 0}
              />
            </div>
          </div>
          <div className="de--reports--accounts--all">
            <ul className="de--reports--accounts--list">
              <li className="de--reports--accounts--list-item">
                <div className="de--reports--accounts--custom-checkbox">
                  <DECheckbox
                    onChange={() => selectAllAccount(!isAllAccountSelected)}
                    id="account_all"
                    isChecked={isAllAccountSelected}
                    indeterminate={isIndeterminate}
                    data-test = 'DECheckboxAll'
                    disabled={accountsList <= 0}
                  />
                  <label
                    htmlFor="account_all"
                    className={`${
                      isAllAccountSelected
                        ? 'de--reports--accounts--label de--reports--accounts--label-selected'
                        : 'de--reports--accounts--label'
                    }`}
                  >
                    <span>All</span>
                  </label>
                </div>
                {isAccountError && (
                  <div className="displayError">
                    Select one or more accounts to export your request
                  </div>
                )}
              </li>
            </ul>
          </div>
          <div className="de--reports--accounts">
            <ul className="de--reports--accounts--list">
              {_renderAccountList()}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

ReportsAccounts.propTypes = {
  accountLoading: bool,
  accounts: instanceOf(Array),
  selectedAccounts: instanceOf(Array),
  onExportAsSeparateChange: func,
  setSelectedAccounts: func,
  setAllSelectedAccounts: func,
  inSingleFile: bool,
  isAccountError: bool,
};
ReportsAccounts.defaultProps = {
  accountLoading: true,
  inSingleFile: false,
  accounts: [],
  selectedAccounts: [],
};

export default ReportsAccounts;
